import { type PropsWithChildren } from "react";

import { Tooltip } from "@vega-core/components/Tooltip/Tooltip";
import { m } from "@vega-core/paraglide/messages";

// Renders the reject reason/comment a GP or LP left when declining, if any.
// GP and LP rejections are mutually exclusive — show whichever is present.
export function RejectDetailsTooltip({
  children,
  rejectComment,
  rejectReason,
  gpRejectReason,
  gpRejectSubreason,
}: PropsWithChildren<{
  rejectComment?: string;
  rejectReason?: string;
  gpRejectReason?: string;
  gpRejectSubreason?: string;
}>) {
  const title = (() => {
    if (rejectReason) {
      return m.coInvestments_tracking_reject_tooltipReason({ rejectReason });
    }

    if (gpRejectReason) {
      return m.coInvestments_tracking_reject_tooltipReason({
        rejectReason: gpRejectReason,
      });
    }

    return undefined;
  })();

  const content = (() => {
    if (rejectComment) {
      return m.coInvestments_tracking_reject_tooltipComment({ rejectComment });
    }

    if (gpRejectSubreason) {
      return m.coInvestments_tracking_reject_gpTooltipSubreason({
        gpRejectSubreason,
      });
    }

    return undefined;
  })();

  return (
    <Tooltip
      content={content}
      providerProps={{ delayDuration: 0 }}
      title={title}
    >
      {children}
    </Tooltip>
  );
}
